<template>
  <dialog-component
    :dialogData="dialogData"
    :isShow="isShow"
    :unitText="'Cancel'"
    @next="handleNext"
    @cancel="handleCancel">
    <div class="email-dialog">
      <select-quote-type v-model="selectType"></select-quote-type>
      <div class="form-item">
        <span class="mg-b-8">Type</span>
        <v-radio-group
          v-model="type"
          block
          :list="selectSMEList"></v-radio-group>
      </div>
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="form-item width-335">
        <span>Source</span>
        <el-form-item
          ref="ref_agency_id"
          :rules="rules.select"
          prop="ref_agency_id">
          <v-select
            v-model="formData.ref_agency_id"
            :list="globalOptions.ref_agency"/>
        </el-form-item>
      </div>
    </el-form>
  </dialog-component>
</template>

<script>
import SelectQuoteType from '@/views/components/select-quote-type'
import {mapActions} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'
export default {
  name: 'selectCreateSeverDialog',
  components: {SelectQuoteType},
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    isCreateSme:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      selectType:'1',
      isShow:false,
      formData:{
        ref_agency_id:''
      },
      type:89,
    }
  },
  computed:{
    dialogData(){
      return{
        title:'Create Quote For',
        buttonRightText:'Confirm'
      }
    },
    severType(){
      return this.selectType==1?'holdcover':'fina'
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
      }
    },
  },
  methods:{
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    handleCancel(){
      this.$emit('input',false)
    },
    handleNext(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.setSelectCustomerData(null)
          this.setCustomerId(null)
          this.setReferCustomerId(null)
          this.setSelectReferCustomerData(null)
          this.$router.push({
            path:`/create/sme/${this.severType}/tickets/${this.type}`,
            query:{
              source:this.formData.ref_agency_id,
            }
          })
        }
      })

    }
  }
}
</script>

<style scoped  lang="scss">
.width-335{
  width: 335px;
}
</style>
